import {
    Avatar,
    AvatarGroup,
    CardContent,
    CardHeader, Chip, IconButton, LinearProgress,
    Table,
    TableBody,
    TableRow,
    Tooltip,
    Typography,
    Dialog, DialogContent,
    DialogTitle,
    CardActionArea, Checkbox, CircularProgress, Button,
    Radio,
} from "@mui/material";
import { styled } from '@mui/styles';
import MuiTableCell from "@mui/material/TableCell";
import nodataimage from "../../assets/svg-images/undraw_no_data_re_kwbl.svg";
import React, { useState, useEffect, useContext } from "react";
import { Box } from "./Box";
import { useDrop } from "react-dnd";
import TaskMenu from "./TaskMenu";
import { getDuration, getError, getSuccessMessage, inArray } from "../../store/helpers/common_functions";
import { errorToast, successToast } from "../../helpers/Notification";
import FormDialog from "../../helpers/FormDialog";
import DeleteDialog from "../../helpers/DeleteDialog";
import { AddTask } from "@mui/icons-material";
import moment from "moment";
import StyledBadge from "helpers/StyledBadge";
import { grey } from "@mui/material/colors";
import { downloadUrl } from "Shared/commonFunction";
import WorklogManager from "../../views/admin/WorklogManager";
import CommentManager from "../../views/admin/CommentManager";

import axios from "axios";
import AttachmentManager from "views/admin/AttachmentManager";
import SocketContext from "helpers/SocketContext";
import { connect } from "react-redux";
import { mapStateToProps } from "store/helpers/mapState";
import { mapDispatchToProps } from "store/helpers/mapDispatch";
import secureLocalStorage from "react-secure-storage";


export const stringToColor = (string) => {
    let hash = 0;
    let i;

    for (i = 0; i < string?.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = "#";

    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value?.toString(16)}`.slice(-2);
    }

    return color;
};

export const stringAvatar = (name, fontSize) => {
    const split = (name ?? "--").split(" ");
    return {
        sx: {
            height: 30,
            width: 30,
            fontSize: 15,
            bgcolor: stringToColor(name),
        },
        children: split.length > 1 ? `${split[0][0]}${split[1][0]}`.toUpperCase() : `${split[0][0]}${split[0][1]}`.toUpperCase(),
    };
};
const TableCell = styled(MuiTableCell)({
    root: {
        borderBottom: "none",
    },
});

const ActivityDetails = ({
    project,
    deliverable,
    activity,
    onSuccess,
    isInitiator,
    status,
    title,
    onTaskChange,
    action,
    draggable = true,
    deliverables,
    location,
    selectedMenu,
    allTasks, UpdateTask, assignees, canEdit, partners,
    systemSettings
}) => {


    const [value, setValue] = useState({});
    const [id, setId] = useState();
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [moveOpen, setMoveOPen] = useState(false);
    const [assignOpen, setAssignOpen] = useState(false);
    const [selectedDev, setSelectedDev] = useState([]);
    const [assigning, setAssigning] = useState(false);
    const [logOpen, setLogOpen] = React.useState(false);
    const [open, setOpen] = useState(0);
    const [options, setOptions] = useState([]);
    const [commentOpen, setCommentOpen] = useState(false);
    const[task,setTask]=useState({});
    const [attachmentOpen, setAttachmentOpen] = useState(false);
    const socket = useContext(SocketContext);
    const [assignPartnerOpen, setAssignPartnerOpen] = useState(false);
    const [selectedPartner, setSelectedPartner] = useState({});

    const mainBackground = systemSettings?.mainBackground;

    const setValue0 = (name, val) => {
        if (!name) {
            return null;
        }

        setValue(v => {
            v[name] = val;
            return { ...v };
        });
    }

    // const allTheMeetings = async () => {
    //     const data = await axios.get('api/meeting/?status=completed');
    //     setOptions(data.data.meeting);
    // }
    // useEffect(() => {
    //     allTheMeetings()
    // },
    //     []
    // );


    const tasks =
        allTasks?.filter(
            (task) =>
            (status === "to-do"
                ? task.status === "to-do" || task.status === "on hold"
                : status === "completed"
                    ? task.status === "completed"
                    : task.status === status ||
                    (Array.isArray(status) && inArray(status, task.status)))
        ) ?? [];

    // const onTaskDrag = (event: any, task: any) => {
    //   event.stopPropagation();
    //   if (task?.status === "to-do") {
    //     setStatus("in-progress");
    //   }
    //   if (task?.status === "in-progress") {
    //     setStatus("to-verify");
    //   }
    //   if (task?.status === "to-verify") {
    //     setStatus("completed");
    //   }
    // };

    const [{ canDrop, isOver }, drop] = useDrop(
        () => ({
            accept: 'box',
            drop: () => ({ name: status }),
            collect: (monitor) => ({
                isOver: monitor.isOver(),
                canDrop: monitor.canDrop(),
            }),
        }),
        [project, tasks, deliverable?.status]
    );

    const isActive = canDrop && isOver;
    let backgroundColor = "#f6f6f6";
    if (isActive) {
        backgroundColor =
            isInitiator || status !== "completed" ? "#ffffff" : "#ffd3d3";
    } else if (canDrop) {
        backgroundColor = "#ececec";
    }

    const assignTeam = async () => {
        if (!selectedDev.length) {
            errorToast("Select at least one project member !");
            return;
        }

        setAssigning(true);
        const resp = await UpdateTask(`/api/task/assign/team/${id}`, { team: selectedDev });
        if (resp.status) {
            const loggedUser = JSON.parse(secureLocalStorage.getItem('user'));
            selectedDev.forEach(v => {
                socket.emit('sendNotification', { 
                    resourceId:loggedUser.Resource.id, 
                    receiverId : v,
                    type: 'task_assigned',
                    });
            });
            successToast(getSuccessMessage(resp));
            setAssignOpen(false);
            onSuccess()
        } else {
            errorToast(getError(resp));
        }
        setAssigning(false);
    }

    // assign partner to task 
    const assignPartner = async () => {
        if (!selectedPartner.id) {
            errorToast("Select at least one partner !");
            return;
        }
        setAssigning(true);
        const resp = await UpdateTask(`/api/task/assign/partner/${id}`, { partnerId: selectedPartner?.partner?.id });
        if (resp.status) {
            const loggedUser = JSON.parse(secureLocalStorage.getItem('user'));
            socket.emit('sendNotification', {
                resourceId: loggedUser.Resource.id,
                receiverId: selectedPartner.id,
                type: 'task_assigned',
            });
            successToast(getSuccessMessage(resp));
            setAssignPartnerOpen(false);
            onSuccess()
        } else {
            errorToast(getError(resp));
        }
        setAssigning(false);
    }

    const teamItem = (resource) => {
        const onClick = () => {


            if (selectedDev.filter(v => v === resource.id).length > 0) {
                setSelectedDev(old => old.filter(i => i !== resource.id));
            } else {
                setSelectedDev(old => [...old, resource.id]);
            }
        };


        let checked = selectedDev.filter(v => v === resource.id).length > 0;

        return <div className={`mr-2 relative mb-2`} >
            <div className={'absolute right-0'} style={{ zIndex: "10", top: "-10px" }}>
                <Checkbox onChange={onClick} checked={checked} />
            </div>
            <CardActionArea onClick={onClick}>
                <StyledBadge
                    overlap="circular"
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                // variant="dot"
                >
                    <Avatar
                        sx={{ bgcolor: grey[300], width: 60, height: 60 }}
                        alt={resource.names}
                        src={resource.profile ? `${downloadUrl}/${resource.profile}` : undefined}
                    />
                </StyledBadge>
                <div style={{ width: "130px" }}>
                    <Typography sx={{
                        display: '-webkit-box',
                        overflow: 'hidden',
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: 1,
                    }} variant={'body2'}>{resource.names}</Typography>
                    <div>
                        <Typography sx={{
                            display: '-webkit-box',
                            overflow: 'hidden',
                            WebkitBoxOrient: 'vertical',
                            WebkitLineClamp: 1,
                        }} variant={'subtitle2'} style={{ fontWeight: "bold" }}>{resource.category}</Typography>
                    </div>
                </div>
            </CardActionArea>
        </div>
    }

    return (
        <div style={{
        
        }} className="flex  mt-3  border rounded shadow  px-2">

            <WorklogManager taskId={id} open={logOpen} setOpen={() => setLogOpen(false)} canViewAll={canEdit} />
            <CommentManager taskId={id} task={task} open={commentOpen} setOpen={() => setCommentOpen(false)} onClose={
                () => {
                    setCommentOpen(false);
                }
            }
            onSuccess={onSuccess}
             canViewAll={canEdit} />

            <AttachmentManager taskId={id} task={task} openAttachment={attachmentOpen}  onClose={
                () => {
                    setAttachmentOpen(false);
                }
            }
            onSuccess={onSuccess}
             canViewAll={canEdit} />

            <FormDialog maxWidth={'sm'} open={open > 0} onSuccess={onSuccess} setOpen={setOpen}
                url={open === 1 ? `/api/task/create` : `/api/task/update/${id}`}
                title={open === 1 ? "Create New Sub Activity" : "Update Sub Activity"} fields={[
                    {
                        name: "name",
                        label: "Name",
                        value: value['name'],
                        required: true,
                        setValue: (val) => setValue0('name', val),
                    },
                    {
                        name: "startDate",
                        label: "Start Date",
                        value: value['startDate'],
                        type: 'datetime-local',
                        // required: true,
                        setValue: (val) => setValue0('startDate', val),
                    
                        validate: (v) => {
                            if (deliverable) {
                                if (deliverable?.startDate && moment.utc(v).isBefore(moment.utc(deliverable.startDate), 'minute')) {
                                    return "Start date cannot be before: " + moment.utc(deliverable.startDate).format("YYYY-MM-DD HH:mm");
                                }
                                if (deliverable?.endDate && moment.utc(v).isAfter(moment.utc(deliverable.endDate), 'minute')) {
                                    return "Start date cannot be after: " + moment.utc(deliverable.endDate).format("YYYY-MM-DD HH:mm");
                                }
                            } else if (project) {
                                if (project?.startDate && moment.utc(v).isBefore(moment.utc(project.startDate), 'minute')) {
                                    return "Start date cannot be before: " + moment.utc(project.startDate).format("YYYY-MM-DD HH:mm");
                                }
                                if (project?.endDate && moment.utc(v).isAfter(moment.utc(project.endDate), 'minute')) {
                                    return "Start date cannot be after: " + moment.utc(project.endDate).format("YYYY-MM-DD HH:mm");
                                }
                            }
                            return true;
                        }
                    },

                    {
                        name: "endDate",
                        label: "End Date",
                        value: value['endDate'],
                        // required: true,
                        type: 'datetime-local',
                        minDate: value['startDate'] ? moment(value['startDate']) : null,
                        validate: (v) => {
                            if (deliverable) {
                                if (deliverable?.startDate && moment.utc(v).isBefore(moment.utc(deliverable.startDate), 'minute')) {
                                    return "End date cannot be before: " + moment.utc(deliverable.startDate).format("YYYY-MM-DD HH:mm");
                                }
                                if (deliverable?.endDate && moment.utc(v).isAfter(moment.utc(deliverable.endDate), 'minute')) {
                                    return "End date cannot be after: " + moment.utc(deliverable.endDate).format("YYYY-MM-DD HH:mm");
                                }
                            } else if (project) {
                                if (project?.startDate && moment.utc(v).isBefore(moment.utc(project.startDate), 'minute')) {
                                    return "End date cannot be before: " + moment.utc(project.startDate).format("YYYY-MM-DD HH:mm");
                                }
                                if (project?.endDate && moment.utc(v).isAfter(moment.utc(project.endDate), 'minute')) {
                                    return "End date cannot be after: " + moment.utc(project.endDate).format("YYYY-MM-DD HH:mm");
                                }
                            }
                            return true;
                        },
                        setValue: (val) => setValue0('endDate', val),
                    },
                    {
                        name: "activityId",
                        label: "Activity",
                        value: activity?.id,
                        required: true,
                        hidden: true
                     
                    },
                    {
                        name: "status",
                        label: "Status",
                        value: status,
                        required: true,
                        hidden: true
                    },

                    {
                        name: "description",
                        label: "Task Description",
                        value: value['description'],
                        type: 'textarea',
                        setValue: (val) => setValue0('description', val),
                    },
                    
                ]} />
            <FormDialog maxWidth={'sm'} open={moveOpen} onSuccess={onSuccess} setOpen={setMoveOPen}
                url={`/api/task/update/${id}`}
                title={"Update Task Deliverable"} fields={[
                    {
                        name: "deliverableId",
                        label: "Deliverable",
                        value: value['deliverableId'],
                        required: true,
                        type: 'select',
                        values: deliverables?.filter(v => v.id !== deliverable?.id)?.map(v => ({ label: v.title, value: v.id })),
                        setValue: (val) => setValue0('deliverableId', val),
                    },
                ]} />
            <DeleteDialog open={deleteOpen} setOpen={() => {
                setDeleteOpen(false);
            }} onSuccess={onSuccess} url={`/api/task/delete/${id}`} />
            <Dialog open={assignOpen} onClose={() => setAssignOpen(false)}>
                <DialogTitle>                     {assignees?.length === 0 ? 'There are currently no assignees for this project.' :
                    'Assign Team to this task'}</DialogTitle>
                <DialogContent>
                    <div className={'flex flex-wrap text-center justify-center'}>
                        {assignees?.map(v => teamItem(v.Resource))}
                    </div>
                    <div className={'text-center mt-3'}>
                        {assigning ? <CircularProgress /> : assignees?.length ? <>
                            <div><Button
                              sx={{
                                backgroundColor: mainBackground,
                                color: 'white',
                                '&:hover': {
                                  backgroundColor: mainBackground,
                                },
                              }}
                                 variant={'contained'} onClick={assignTeam}>Assign Team</Button></div>
                            <div>
                                <Button onClick={() => setAssignOpen(false)}>Cancel</Button>
                            </div>
                        </> : null}
                    </div>
                </DialogContent>
            </Dialog>

            <Dialog open={assignPartnerOpen} onClose={() => setAssignPartnerOpen(false)}>
                <DialogTitle>                     {partners?.length === 0 ? 'There are currently no partners for this project.' :
                    'Assign Partner to this task'}</DialogTitle>
                <DialogContent>
                    <div className={'flex flex-wrap text-center justify-center'}>
                        {partners?.map(v => {
                            // add radio button to select partner
                            return <div className={`mr-2 relative mb-2`} >
                                   {/* radio button to select only one partner */}
                                <div className={' right-0'} style={{ zIndex: "10", top: "-10px" }}>
                                    <Radio
                                        onChange={() => {
                                            if (selectedPartner.id === v.id) {
                                                setSelectedPartner({});
                                            } else {
                                                setSelectedPartner(v);
                                            }
                                          
                                        }}
                                        checked={selectedPartner.id === v.id}
                                    /> 
                                    <span className="text-xs text-gray-500">
                                        {v?.partner?.name}
                                    </span>

                                        </div>
                               </div>
                          
                        })}
                    </div>
                    <div className={'text-center mt-3'}>
                        {assigning ? <CircularProgress /> : partners?.length ? <>
                            <div><Button
                              sx={{
                                backgroundColor: mainBackground,
                                color: 'white',
                                '&:hover': {
                                  backgroundColor: mainBackground,
                                },
                              }}
                                 variant={'contained'} onClick={assignPartner}>Assign Partner</Button></div>
                            <div>
                                <Button onClick={() => setAssignPartnerOpen(false)}>Cancel</Button>
                            </div>
                        </> : null}
                    </div>
                </DialogContent>
            </Dialog>

            <div
                ref={drop}

                data-testid={status}
               className="w-full px-2 "
                style={{
                    overflow: "auto",
                 
                    height: "370px",
                }}
              
            >
                <CardHeader
                    action={action ? <IconButton onClick={() => setOpen(1)}>
                        <AddTask />
                    </IconButton> : undefined}
                    title={title}
                    titleTypographyProps={{ variant: "subtitle2" }}
                    style={{ padding: "10px" }}
                />
                <CardContent style={{ padding: "10px" }}>
                    <Table>
                        <TableBody>
                            {tasks?.length ? (
                                tasks?.map((task, key) => {
                                    const duration = task?.startDate ? getDuration(task.endDate, task.startDate) : null

                                    return <TableRow
                                        // draggable="true"
                                        // onDragEnd={(e: any) => onTaskDrop(e, task)}
                                        // onDrag={(e: any) => onTaskDrag(e, task)}
                                        key={key}
                                    // onClick={() => {
                                    //   history.push(`/task`, task);
                                    // }}
                                    >
                                        <TableCell colSpan={5} padding={"none"}>
                                            {
                                                <>
                                                    <div className={"mt-1 w-full"}>
                                                        <Box

                                                            className={"bg-primary"}
                                                            draggable={canEdit}
                                                            key={`${task.id}${deliverable?.status ?? ""}`}
                                                            onDrop={(id, status) => {

                                                                // if (!(task?.deliverableId ? deliverable?.status === 'in-progress' : draggable)) {
                                                                //     errorToast(
                                                                //         `Task status cannot be changed because deliverable or project is not in progress`
                                                                //     );
                                                                // }
                                                                 if (status === 'overdue') {
                                                                    errorToast(
                                                                        `Task cannot be moved to overdue`
                                                                    );
                                                                }
                                                                else if (isInitiator || status !== "completed") {
                                                                    onTaskChange({
                                                                        id,
                                                                        status,
                                                                    });
                                                                } else {
                                                                    errorToast(
                                                                        `Task can only be completed by supervisor or initiator`
                                                                    );
                                                                }


                                                            }}
                                                            name={task?.name}
                                                            id={task?.id}
                                                            content={
                                                                <div className="w-full">
                                                                    <div className={"flex items-center"}>
                                                                        <AvatarGroup max={2} sx={{
                                                                            '& .MuiAvatar-root': { width: 24, height: 24, fontSize: 15 },
                                                                        }}>
                                                                            {task?.TaskAssignees?.map(item => <Tooltip arrow={true}
                                                                                title={item?.Resource?.names}
                                                                            >

                                                                                <Avatar
                                                                                    {...stringAvatar(
                                                                                        `${item.Resource.names ?? ""}`
                                                                                    )}
                                                                                />
                                                                            </Tooltip>)}
                                                                        </AvatarGroup>
                                                                        <div className={"flex-grow pl-3 text-sm"}>
                                                                            {task.name}
                                                                        </div>
                                                                        <div className="flex items-center gap-4 px-2">
                                                                            {task?.task_attachments?.length > 0 && (
                                                                                <Tooltip >
                                                                                <div className="relative flex items-center">
                                                                                    <span
                                                                                    style={{
                                                                                        top: "-6px",
                                                                                        right: "-10px",
                                                                                        padding: "2px",
                                                                                        fontSize: "10px",
                                                                                        backgroundColor: mainBackground,
                                                                                    }}
                                                                                    className="absolute  bg-red-600 text-white rounded-full font-bold flex items-center justify-center">
                                                                                    {task.task_attachments.length}
                                                                                    </span>
                                                                                    <i className="fas fa-paperclip text-blueGray-500 text-lg"></i>
                                                                                </div>
                                                                                </Tooltip>
                                                                            )}
                                                                            {task?.task_comments?.length > 0 && (
                                                                                <Tooltip  onClick={
                                                                                    ()=> setCommentOpen(true)
                                                                                }
                                                                                onMouseOver={
                                                                                    (e) => {
                                                                                        e.stopPropagation();
                                                                                        // set mouse type to pointer
                                                                                        e.target.style.cursor = "pointer";
                                                                                    }
                                                                                }
                                                                                >
                                                                                <div className="relative flex items-center">
                                                                                <span
                                                                                    style={{
                                                                                        top: "-6px",
                                                                                        right: "-7px",
                                                                                        padding: "2px",
                                                                                        fontSize: "10px",
                                                                                        backgroundColor: mainBackground,
                                                                                    }}
                                                                                    className="absolute  bg-red-600 text-white rounded-full font-bold flex items-center justify-center">
                                                                                    {task.task_comments.length}
                                                                                    </span>
                                                                                    <i className="fas fa-comment text-blueGray-500 text-lg"></i>
                                                                                </div>
                                                                                </Tooltip>
                                                                            )}
                                                                            </div>
                                                                        <span className="mr-2 text-cyan-600 text-sm">
                                                                            {duration}
                                                                        </span>

                                                                        {isInitiator && status !== null ? (//
                                                                            <TaskMenu
                                                                                onEdit={() => {
                                                                                    setOpen(2);
                                                                                    setId(task.id);
                                                                                    setValue0('name', task.name);
                                                                                    setValue0('startDate', moment(task.startDate).utc().format("YYYY-MM-DD HH:mm"));
                                                                                    setValue0('endDate', moment(task.endDate).utc().format("YYYY-MM-DD HH:mm"));
                                                                                    setValue0('description', task.description);
                                                                                }}
                                                                                onDelete={() => {
                                                                                    setDeleteOpen(true);
                                                                                    setId(task.id);
                                                                                }}
                                                                                onAssign={() => {
                                                                                    setAssignOpen(true);
                                                                                    setId(task.id);

                                                                                }}
                                                                                extra={[
                                                                                    {
                                                                                        label: "WORKLOGS",
                                                                                        onClick: () => {
                                                                                            setLogOpen(true);
                                                                                            setId(task.id);
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        label:"COMMENTS",
                                                                                        onClick:()=>{
                                                                                            setCommentOpen(true);
                                                                                            setId(task.id);
                                                                                            setTask(task);
                                                                                        }

                                                                                    },
                                                                                    {
                                                                                        label:"ATTACHMENTS",
                                                                                        onClick:()=>{
                                                                                            setAttachmentOpen(true);
                                                                                            setId(task.id);
                                                                                            setTask(task);

                                                                                        }

                                                                                    }
                                                                                ]}
                                                                            />
                                                                        ) : (
                                                                            <div className={"me-2"}></div>
                                                                        )}
                                                                    </div>
                                                                    {task.loading ? (
                                                                        <LinearProgress />
                                                                    ) : null}
                                                                </div>
                                                            }
                                                        />
                                                    </div>
                                                </>
                                            }
                                        </TableCell>
                                    </TableRow>

                                })
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={3}>
                                        <div className={'text-center'}>
                                            <img
                                                className="mt-6 float-center"
                                                src={nodataimage}
                                                style={{ display: "inline-block" }}
                                                alt="no data"
                                                height={70}
                                                width={70}
                                            />
                                            <div className="mt-2">
                                                <Typography variant={"h6"}>No task yet</Typography>
                                            </div>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </CardContent>
            </div>
        </div>
    );
};
export default connect(mapStateToProps, mapDispatchToProps)(ActivityDetails);
